module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAA5ElEQVRYhe2XQQrCMBBFn7W6cuUFXHkUT1BEFEG8gzcQvIZuBBV6D+/gyo0HEBeiKDIQoSBd5BNohXwITAp/5pEJTNq40N0BI/z0BObA1rnGwAZoe+bJE6G4qQVkhf1QKG7KEsH0VVISy0kqUQSIABEgAtQC4CF6byEAUmDmhknTw3cFlqEAdm5VosrvgJ3AxM12pQWnEABr8TFhpzd18UsFSMTipk4hPgB3Icc+FYv/JHLLW7W4hCFkj9SB0M5jKIAVsBB851At6Iu+XpyGEeCvAd4lsTdALvjs97zos9i++QnyD8W5H0nvNhhaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_educloud/icon_k1.png
// module id = VwTk
// module chunks = 0